export function trackById<T extends { id: number }>(index: number, t: T): number {
  return t.id;
}
